import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { ProductContext } from "../../context/ProductContext";
import { PRODUCT_CHUNK } from "../../utils/global_const";
import { useTranslation } from "react-i18next";
import ProductCard from "../../components/product/ProductCard";
import Filter from "../../components/product/Filter";
import ProductCardHorizontal from "../../components/product/ProductCardHorizontal";
import ShopSort from "../../components/product/ShopSort";
import CategoryHero from "../../components/hero/CategoryHero";
import Breadcrumbs from "../../components/section/BreadCrumbs";
import axios from "axios";
import APIService from "../../services/APIService";
import { useParams } from "react-router-dom";

import brandDescriptions from "../../brand_descriptions.json";

const Container = styled.article`
  color: ${(props) => props.theme.textColor};
`;
const Section = styled.section`
  width: 100%;
  @media (min-width: 1025px) {
    width: var(--max-width-container);
  }
`;
const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;

  @media (min-width: 768px) and (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }

  @media (min-width: 1025px) {
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
  }
`;
const FlexDiv = styled.div`
  height: var(--navbar-height);
  //position: sticky;
  //left: 0;
  //top: calc(var(--navbar-height) + var(--navbar-mini));
  //flex-direction: row-reverse;

  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-large);

  @media (min-width: 768px) {
    //max-width: 90%;
    box-shadow: none;
    flex-direction: row;
    position: static;
    margin-bottom: 20px;
  }
  @media (min-width: 1025px) {
    width: var(--max-width-container);
  }
`;
const MarginDiv = styled.div`
  width: 96%;
  margin: 0 auto;
`;
const TopWrapper = styled.div`
  width: 96%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  @media (min-width: 768px) {
    width: 20%;
    margin-left: auto;
  }
`;
const FlexContainer = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;
  gap: 6px;
`;

const FilterContainer = styled.div`
  width: 100%;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  margin: 14px 0;
`;

// Stil za opis sa glass efekatom i delimičnim sakrivanjem
const Description = styled.p`
  max-height: ${(props) =>
    props.showAll ? "none" : "70px"}; // Skriva deo teksta
  overflow: hidden;
  position: relative;
  transition: max-height 0.3s ease-in-out;
  max-height: ${(props) =>
    props.$showMore ? "100vh" : "calc(4 * var(--font-size-base))"};

  &::after {
    content: "";
    position: absolute;

    left: 0;
    right: 0;
    top: 0;
    box-shadow: 0px 15px 24px 30px rgba(251, 251, 251, 0.75);
    -webkit-box-shadow: 0px 15px 24px 30px rgba(251, 251, 251, 0.75);
    -moz-box-shadow: 0px 15px 24px 30px rgba(251, 251, 251, 0.75);
    display: ${(props) => (props.$showMore ? "none" : "block")};
    height: 60%;
  }
  @media (min-width: 768px) {
    max-width: 50%;
  }
`;
const Button = styled.div`
  border: none;
  background-color: transparent;
  color: var(--text-100);
  border-color: var(--text-100);
  &:hover {
    background-color: transparent;
    color: var(--text-100);
    border-color: var(--text-100);
  }
  margin: 8px 0 20px 0;
  display: flex;
  align-items: center;
`;
const Disclaimer = styled.div`
  font-size: var(--font-size-large);
  max-width: 94%;
  @media (min-width: 765px) {
    font-size: var(--font-size-xxlarge);
    max-width: 100%;
  }
  border: 2px solid var(--text-100);
  color: var(--text-100);
  border-radius: 8px;
  text-align: center;
  padding: 14px 0;
  margin: 24px auto;
`;

const PaginationWrapper = styled.div`
  margin-top: 30px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
`;

const PageButton = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  background-color: ${({ disabled }) =>
    disabled ? "#ccc" : "var(--primary-100)"};
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: background-color 0.3s;
`;

const ProgressBarWrapper = styled.div`
  margin-top: 15px;
  width: 300px;
  height: 8px;
  background-color: var(--bg-300);
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
`;

const ProgressFill = styled.div`
  height: 100%;
  width: ${({ progress }) => progress}%;
  background-color: var(--primary-100);
  border-radius: 10px;
  transition: width 0.4s ease;
`;

const ShopMain = () => {
  const { t, i18n } = useTranslation();
  const { slug } = useParams();
  const { products, category, totalPages, currentPage, setCurrentPage } =
    useContext(ProductContext);

  const [loading, setLoading] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);

  const handleShowMore = () => {
    setShowMore((prev) => !prev);
  };
  const handleSetOpenIndex = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  // Pokušaj da nađeš opis za slug iz JSON-a
  const entry = slug
    ? brandDescriptions.find((item) => item.slug === slug)
    : null;

  // Odredi jezik i ključ za opis
  const lang = i18n.language === "de" ? "de" : "en";
  const descKey = lang === "de" ? "short_desc_de" : "short_desc_en";

  // Sastavi title i description
  const titleText = entry
    ? slug
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : category
    ? category.name
    : t("SHOP.TITLE");

  const descriptionText = entry
    ? entry[descKey]
    : category
    ? category.seo_data.description
    : null;

  const breadcrumbItems = [
    { name: "SnusCo", url: "/" },
    { name: titleText, url: "/snus-verkauf" },
  ];

  return (
    <Container>
      <Section className="header-top-margin">
        <MarginDiv>
          <Breadcrumbs breadcrumbs={breadcrumbItems} />

          <Title>{titleText}</Title>

          {descriptionText ? (
            <Description $showMore={showMore}>{descriptionText}</Description>
          ) : (
            <Description
              $showMore={showMore}
              dangerouslySetInnerHTML={{ __html: t("SHOP.DESCRIPTION") }}
            />
          )}

          <Button onClick={handleShowMore}>
            {showMore ? (
              <>
                {t("SHOP.SEE_LESS")}
                <svg
                  fill="var(--text-100)"
                  width="24px"
                  height="24px"
                  viewBox="0 0 1024 1024"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M759.2 419.8L697.4 358 512 543.4 326.6 358l-61.8 61.8L512 667z" />
                </svg>
              </>
            ) : (
              <>
                {t("SHOP.SEE_MORE")}
                <svg
                  fill="var(--text-100)"
                  width="24px"
                  height="24px"
                  viewBox="0 0 1024 1024"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ transform: "rotate(180deg)" }} // Ispravljeno
                >
                  <path d="M759.2 419.8L697.4 358 512 543.4 326.6 358l-61.8 61.8L512 667z" />
                </svg>
              </>
            )}
          </Button>
        </MarginDiv>
        <FlexDiv>
          <TopWrapper>
            <FilterContainer>
              <Filter />{" "}
            </FilterContainer>
            <FilterContainer>
              <ShopSort />
            </FilterContainer>
          </TopWrapper>
        </FlexDiv>
        <Disclaimer>{t("SHOP.DISCLAIMER")}</Disclaimer>
        <ProductGrid>
          {loading ? (
            <p>{t("SHOP.LOADING")}</p>
          ) : (
            products.map((product, index) => (
              <ProductCard
                key={index}
                product={product}
                isOpen={openIndex === index}
                setIsOpen={() => handleSetOpenIndex(index)}
              />
            ))
          )}
        </ProductGrid>
        <div>
          <PaginationWrapper>
            <PageButton
              onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
              disabled={currentPage <= 1}
            >
              {t("SHOP.PREVIOUS")}
            </PageButton>

            <PageButton
              onClick={() => setCurrentPage((prev) => prev + 1)}
              disabled={currentPage >= totalPages}
            >
              {currentPage >= totalPages ? t("SHOP.NO_MORE") : t("SHOP.NEXT")}
            </PageButton>
          </PaginationWrapper>
          <ProgressBarWrapper>
            <ProgressFill progress={(currentPage / totalPages) * 100} />
          </ProgressBarWrapper>
        </div>
      </Section>
    </Container>
  );
};

export default ShopMain;
